import React, { useState, useEffect } from "react";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL
  
  
const SAFETY_COLORS = [
  "bg-green-600",
  "bg-green-400",
  "bg-yellow-400",
  "bg-orange-500",
  "bg-red-600",
];

// Status Badge Component for Reusability
const StatusBadge = ({ status }) => {
  const styles = {
    "High Risk": "bg-red-100 text-red-700",
    Moderate: "bg-orange-100 text-orange-700",
    Resolved: "bg-green-100 text-green-700",
    Pending: "bg-blue-100 text-blue-700",
  };
  return (
    <span
      className={`px-3 py-1 rounded-full text-xs font-bold ${
        styles[status] || "bg-gray-100 text-gray-600"
      }`}
    >
      {status}
    </span>
  );
};

const Safeguarding = () => {
  const [safetyPerception, setSafetyPerception] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/safety-perception`)
      .then((response) => {
        const res = response.data;
        if (res.success && Array.isArray(res.safetyPerception)) {
          setSafetyPerception(
            res.safetyPerception.map((item, index) => ({
              label: item.label,
              percent: item.percent,
              color: SAFETY_COLORS[index % SAFETY_COLORS.length],
            }))
          );
        }
      })
      .catch((error) =>
        console.error("Error fetching safety perception:", error)
      );
  }, []);

  const reportedRisks = [
    {
      id: "SR-102",
      type: "Infrastructure",
      date: "Jan 05",
      status: "High Risk",
    },
    { id: "SR-098", type: "Equipment", date: "Jan 03", status: "Resolved" },
    { id: "SR-095", type: "Environmental", date: "Dec 28", status: "Moderate" },
    { id: "SR-091", type: "Infrastructure", date: "Dec 24", status: "Pending" },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6">
      {/* Card 1: Safety Perception (Survey Style) */}
      <div className="bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100">
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          Safety Perception
        </h2>
        <p className="text-gray-500 text-sm mb-8">
          How employees feel about the workspace
        </p>

        <div className="space-y-6">
          {safetyPerception.length > 0 ? (
            safetyPerception.map((item, index) => (
              <div key={index} className="group">
                <div className="flex justify-between mb-2">
                  <span className="text-sm font-semibold text-gray-700">
                    {item.label}
                  </span>
                  <span className="text-sm font-bold text-gray-900">
                    {item.percent}%
                  </span>
                </div>
                <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${item.color} rounded-full transition-all duration-1000 ease-out`}
                    style={{ width: `${item.percent}%` }}
                  ></div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500">No safety perception data yet.</p>
          )}
        </div>
      </div>

      {/* Card 2: Reported Safety Risks (Table Style) */}
      <div className="bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h2 className="text-xl font-bold text-gray-900">
              Reported Safety Risks
            </h2>
            <p className="text-gray-500 text-sm">Recent incident reports</p>
          </div>
          <button className="text-green-700 text-sm font-bold hover:underline">
            View All
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-gray-100 text-gray-400 text-xs uppercase tracking-wider">
                <th className="pb-4 font-bold">Risk ID</th>
                <th className="pb-4 font-bold">Category</th>
                <th className="pb-4 font-bold">Date</th>
                <th className="pb-4 font-bold text-right">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {reportedRisks.map((risk, index) => (
                <tr
                  key={index}
                  className="group hover:bg-gray-50 transition-colors"
                >
                  <td className="py-4 text-sm font-bold text-gray-900">
                    {risk.id}
                  </td>
                  <td className="py-4 text-sm text-gray-600">{risk.type}</td>
                  <td className="py-4 text-sm text-gray-400">{risk.date}</td>
                  <td className="py-4 text-right">
                    <StatusBadge status={risk.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Safeguarding;
